import { filter, map } from 'rxjs/operators';
import { Epic } from 'redux-observable';
import { RootAction } from 'typesafe-actions';

import { startRequestLoading, endRequestLoading } from '../actions/ui';
import { getCall } from '../utils/apiLoading';
import {
  requestFlowActionsRegex,
  requestActionRegex,
} from '../constants/apiLoading';

/**
 * Epic for handling which api call is being sent and which is done
 */
export const apiLoadingEpic: Epic<RootAction> = (action$) =>
  action$.pipe(
    filter((action) => requestFlowActionsRegex.test(action.type)),
    map((action) => {
      const { type } = action;
      const isRequestBeingSent = requestActionRegex.test(type);
      const call = getCall(type);

      if (isRequestBeingSent) {
        return startRequestLoading(call);
      }

      return endRequestLoading(call);
    })
  );

export default apiLoadingEpic;
